import { ShipmentDelivery } from "./delivery/shipment-delivery.model";
import { Shipment } from "./shipment";

export class DeliveryNoteRequest {

    orderQuery: Shipment;
    orderDelivery: ShipmentDelivery;

    constructor(orderQuery: Shipment, orderDelivery: ShipmentDelivery) {
        this.orderQuery = orderQuery;
        this.orderDelivery = orderDelivery;
    }
}
